import React from 'react'
import { Button, Header, Icon, Modal, Segment, Form, Divider, Image, Grid, Input} from 'semantic-ui-react'

import RichTextEditor from 'react-rte';


const toolbarConfig = {
    // Optionally specify the groups to display (displayed in the order listed).
    display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS','HISTORY_BUTTONS', 'IMAGE_BUTTON'],
    INLINE_STYLE_BUTTONS: [
      {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
      {label: 'Italic', style: 'ITALIC'},
      {label: 'Underline', style: 'UNDERLINE'}
    ],
    BLOCK_TYPE_BUTTONS: [
      {label: 'UL', style: 'unordered-list-item'},
      {label: 'OL', style: 'ordered-list-item'}
    ]
  };

const config = {
		readonly: false // all options from https://xdsoft.net/jodit/doc/
	}



const ModalComentarios = ({comentarios=[],showModal, closeModal, icono, texto, titulo, handleState, customInputFunc, userId, name="", handleStateNewComment, addText, textComment, reply, onReply, onReplyDelete, onCancelReply, onComentarioDelete, setContent, value, botonComentario, onEditar, edit,onContentEdit, onSaveComent, editReply, onEditarReply, onReplyEdit, onSaveReply, onChange, datos }) => (
    
  
    <Modal  open={showModal} basic size='large' >
            
            <Modal.Content scrolling>

                <Form>
                    
                    
                    {reply==0 && edit==0?
                        <Segment style={{ background: "#FFFFFF",color:"#000000"}}>    
                        <Form>
                            <h4>Nuevo comentario</h4>
                                <Grid columns={datos.imagePreviewUrl==''?1:2} padded>     
                                <Grid.Column  width={datos.imagePreviewUrl==''?16:12}>
                                    <RichTextEditor
                                        rootStyle={{
                                              fontFamily: 'sans-serif'
                                            }}
                                        toolbarConfig={toolbarConfig}
                                        value={value}
                                        onChange={value=>setContent(value)}
                                        placeholder="Agrega tu comentario"
                                    /> 
                                 </Grid.Column>
                                 {datos.imagePreviewUrl!=''?       
                                     <Grid.Column width={4}>
                                      
                                            <img src={datos.imagePreviewUrl} width="200" />
                                      
                                    </Grid.Column>
                                 :
                                 ""
                                 }
                            </Grid>    
                            <Input placeholder='foto'
                                onChange={onChange}
                                name="adjunto"                    
                                type='file'

                            />        
                            <Button content={reply==0?"Agregar comentario":"Agregar respuesta"} 
                                labelPosition='right' icon='edit' color="teal" 
                                onClick={()=>handleStateNewComment(0)} disabled={botonComentario}  
                            />
                            
                            
                            
                            
                            
                            <br/>    
                        </Form>
                        </Segment>    

                    :
                       ""
                    }
                    

                </Form>
            
                
                
                {comentarios.map(renglon =>
    
                    <Segment style={{ background: "#EEEEEE",color:"#000000"}} >
                            <br/>   
                            <Grid padded>
                            <Grid.Row columns="2" >     
                               <Grid.Column width="2" only='computer tablet '> 
                                 {renglon.avatarUrl!=null?
                                    <Image src={renglon.avatarUrl} size='tiny' centered circular/>
                                 :
                                    <Image src="/images/usuarioAvatar.png" size='tiny' centered circular/>
                                 }
                                </Grid.Column>      
                                 
                                <Grid.Column width="14" >       
                                 
                                    <Button.Group size='small' floated='left'>

                                        {Number(renglon.instructor)==1?
                                            <Button icon labelPosition='right' color='facebook' >
                                                {renglon.fullName}-[INSTRUCTOR]

                                            </Button>
                                        : 
                                            <Button icon labelPosition='right' color='linkedin'>
                                                {renglon.fullName}
                                            </Button>

                                        }
                                    </Button.Group>
                            
                                    
                                    
                            
                                <Button.Group  size='mini' floated='right'>
                                    
                                    
                                <Button icon labelPosition='right'  >
                                           {renglon.fecha}
                                            <Icon name='calendar' />     
                                        </Button>       
                
                                {userId==renglon.userId && renglon.replies.length==0 &&  edit==0 ?
                                        
                                 
                                        <Button size='mini' icon labelPosition='right'  onClick={()=>onComentarioDelete(renglon.comId)} >
                                            Borrar
                                            <Icon name='delete' color="red" />     
                                        </Button>
                                    :
                                        ""
                                }

                                {userId==renglon.userId &&  edit==0?
                                       
                                        <Button size='mini' icon labelPosition='right' onClick={()=>onEditar(renglon.comId)} >
                                        Editar
                                            <Icon name='write' color="green" />     
                                        </Button>
                                    :
                                        ""
                                }

                                {userId==renglon.userId && edit==renglon.comId?
                                        <Button size='mini' icon labelPosition='right'  onClick={()=>onSaveComent(renglon.comId)} >
                                        Guardar
                                            <Icon name='save' color="green" />     
                                        </Button>    
                                    :
                                        ""
                                }
                    
                                </Button.Group>
                                <br/>
                                <br/>
                                <Grid width={renglon.imagePreviewUrl==''?1:2} padded>
                                    <Grid.Column width={renglon.imagePreviewUrl==''?16:12}>
                                        <RichTextEditor
                                            rootStyle={{
                                              fontFamily: 'sans-serif'
                                            }}
                                            config={config}
                                            toolbarConfig={toolbarConfig}
                                            value={renglon.value}
                                            onChange={value=>onContentEdit(value)}
                                            readOnly={edit==renglon.comId?false:true}
                                        /> 
                                    </Grid.Column>    
                                
                                 {renglon.imagePreviewUrl!=''?       
                                     <Grid.Column width={4}>
                                      
                                            <img src={renglon.imagePreviewUrl} width="180" />
                                      
                                    </Grid.Column>
                                 :
                                 ""
                                 }
                                </Grid>    

                                <br/>
                                {reply>0 && reply==renglon.comId?
                                    <Segment basic>
                                    <Form>
                                        <h4>Respuesta para al comentario</h4>
                                        <Grid columns={datos.imagePreviewUrl==''?1:2} padded>     
                                            <Grid.Column  width={datos.imagePreviewUrl==''?16:12}>

                                                <RichTextEditor
                                                    rootStyle={{
                                                      fontFamily: 'sans-serif'
                                                    }}
                                                    toolbarConfig={toolbarConfig}
                                                    value={value}
                                                    onChange={value=>setContent(value)}
                                                    placeholder="Agrega tu comentario"
                                                />
                                            </Grid.Column>
                                            {datos.imagePreviewUrl!=''?       
                                                <Grid.Column width={4}>
                                                    <img src={datos.imagePreviewUrl} width="200" />
                                                </Grid.Column>
                                            :
                                                ""
                                            }
                                        </Grid>            
                                             
                                                    
                                            <br/>
                                            <Input placeholder='foto'
                                                onChange={onChange}
                                                name="adjunto_replay"                    
                                                type='file'

                                            />      
                                                
                                          
                                                
                                        <Button.Group>    
                                            <Button content={reply==0?"Agregar nuevo comentario":"Agregar respuesta"}
                                                labelPosition='right' icon='edit' color="teal"  
                                                onClick={()=>handleStateNewComment(renglon.comId)} disabled={botonComentario} 
                                            />
                                            <Button size='mini' content='Cancelar' labelPosition='left' icon='cancel' 
                                                onClick={onCancelReply} 
                                            />
                                        </Button.Group>
                                    </Form>
                                    </Segment>        
                                :
                                    <Button size='mini' content='Responder comentario' labelPosition='right' icon='edit' onClick={()=>onReply(renglon.comId)} />

                                }
                            
                            
                        {renglon.replies.map(replay=>
                          <Segment basic padded>
                               <Grid padded>
                            <Grid.Row columns="2" >     
                               <Grid.Column width="2" only='computer tablet '>  
                                    {replay.avatarUrl!=null?
                                        <Image src={replay.avatarUrl} size='tiny' centered circular/>
                                     :
                                        <Image src="/images/usuarioAvatar.png" size='tiny' centered circular/>
                                     }         
                                             
                                </Grid.Column>      
                                 
                                <Grid.Column width="14" >                
                                <Button.Group size='mini' floated='left'>

                                    {Number(replay.instructor)==1?
                                        <Button icon labelPosition='right' color='facebook' >
                                            {replay.fullName}-[INSTRUCTOR]
                                        </Button>
                                    : 
                                        <Button icon labelPosition='right' color='linkedin'>
                                            {replay.fullName}
                                        </Button>
                                    }
                                </Button.Group>             
                                
                                <Button.Group size='mini' floated='right'>
                                    
                                <Button icon labelPosition='right'  >
                                           {replay.fecha}
                                            <Icon name='calendar' />     
                                        </Button>    
                
                                {userId==replay.userId &&  editReply==0?
                                    
                                        <Button icon labelPosition='right' onClick={()=>onReplyDelete(renglon.comId, replay.comId)} >
                                            Borrar
                                            <Icon name='delete' color="red" />     
                                        </Button>
                                    :
                                        ""
                                }

                                {userId==replay.userId &&  editReply==0?
                                       
                                        <Button icon labelPosition='right' onClick={()=>onEditarReply(renglon.comId, replay.comId)} >
                                            Editar
                                            <Icon name='write' color="green" />     
                                        </Button>
                                    :
                                        ""
                                }
                    
                            

                                {userId==replay.userId && editReply==replay.comId?
                                        <Button icon labelPosition='right' onClick={()=>onSaveReply()} >
                                            Guardar
                                            <Icon name='save' color="green" />     
                                        </Button>
                                    :
                                        ""
                                }
                    
                                </Button.Group>
                                
                              
                                

                                <br/><br/>  
                                    
                                <Grid width={replay.imagePreviewUrl==''?1:2} padded>
                                    <Grid.Column width={replay.imagePreviewUrl==''?16:12}>    
                                    
                                        <RichTextEditor
                                            rootStyle={{
                                              fontFamily: 'sans-serif'
                                            }}
                                            config={config}
                                            toolbarConfig={toolbarConfig}
                                            value={replay.value}
                                            onChange={value=>onReplyEdit(value)}
                                            readOnly={editReply==replay.comId?false:true}
                                        /> 
                                
                                    </Grid.Column>    
                                
                                    {replay.imagePreviewUrl!=''?       
                                     <Grid.Column width={4}>
                                      
                                            <img src={replay.imagePreviewUrl} width="180" />
                                      
                                    </Grid.Column>
                                    :
                                    ""
                                    }
                                </Grid>    
                                

                                
                              </Grid.Column>   
                            </Grid.Row>    
                            </Grid>        
                                
                          </Segment>
                        )}
                             </Grid.Column>   
                            </Grid.Row>    
                            </Grid>    
                                
                    </Segment>
                    
                )}
                
            </Modal.Content>

            <Modal.Actions>
                <br/>
                <Button  color='red' onClick={closeModal}>
                    <Icon name='remove' /> Cerrar
                </Button>
                <br/>    
            </Modal.Actions>
        
    </Modal>
    
    
 
   
)

export default ModalComentarios